export const ACCOUNT_ADMINISTRATION_SENDGRID_COMMON_MESSAGE = 'There is an issue with the SendGrid information.';
export const ACCOUNT_ADMINISTRATION_SENDGRID_INVALID_KEY = 'Invalid API Key';
export const ACCOUNT_ADMINISTRATION_SENDGRID_INVALID_TEMPLATE = 'Invalid Template ID';
export const ACCOUNT_ADMINISTRATION_SENDGRID_ERRORS = ['The SendGrid template does not exist'];
export const ACCOUNT_ADMINISTRATION_ERROR_CODES = {
  SENDGRID_AUTH_FAILURE: {
    errorCode: 5179,
    error: 'Your SendGrid API key is invalid',
    type: 'SENDGRID_AUTH_FAILURE',
  },

  SENDGRID_TEST_AUTH_FAILURE: {
    errorCode: 5184,
    error: 'Your SendGrid Sandbox API key is invalid',
    type: 'SENDGRID_AUTH_FAILURE',
  },

  EMAIL_TEMPLATE_ID_DNE: {
    errorCode: 7104,
    error: 'No email template with that id',
    type: 'EMAIL_TEMPLATE_ID_DNE',
  },

  EMAIL_TYPE_NOT_UNIQUE: {
    errorCode: 7103,
    error: 'Email Template Type is already assigned',
    type: 'EMAIL_TYPE_NOT_UNIQUE',
  },
} as const;
